export const getHasRowParsedData = (
  showSourceIcons?: boolean,
  hasParsedData?: boolean,
) => {
  if (!showSourceIcons) {
    return undefined
  }
  return hasParsedData || false
}
